// src/components/ui/LenderSideNav.jsx
import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  PieChart,
  Upload,
  List,
  LineChart,
  UserCircle2,
  Cog,
  LogOut,
} from "lucide-react";
import Card from "./Card.jsx";
import { signOut } from "../../api/client";
import SleekSignOutDialog from "./SleekSignOutDialog.jsx";

export default function LenderSideNav({ onClose }) {
  const navigate = useNavigate();
  const [showSignOutModal, setShowSignOutModal] = useState(false);

  const handleSignOutClick = () => {
    setShowSignOutModal(true);
  };

  const handleConfirmSignOut = async () => {
    await signOut();
    localStorage.removeItem("ds_isAuthed");
    sessionStorage.removeItem("ds_isAuthed");
    navigate("/signin?force=true", { replace: true });
  };

  const navItems = [
    { to: "/lender/overview", label: "Overview", Icon: PieChart },
    { to: "/lender/upload", label: "Upload Products", Icon: Upload },
    { to: "/lender/listed", label: "Listed Products", Icon: List },
    { to: "/lender/analytics", label: "Analytics", Icon: LineChart },
    { to: "/lender/profile", label: "Profile", Icon: UserCircle2 },
    { to: "/lender/settings", label: "Settings", Icon: Cog },
  ];

  const linkClass = ({ isActive }) =>
    `w-full flex items-center gap-3 px-4 py-3 text-left rounded-xl ${isActive
      ? "bg-sky-400 text-white shadow-sm"
      : "text-gray-700 hover:bg-gray-50"
    }`;

  return (
    <aside className="h-full">
      <Card className="p-3 h-full">
        <nav className="flex flex-col gap-1.5">
          {navItems.map(({ to, label, Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={linkClass}
              onClick={() => onClose?.()}
            >
              <Icon className="h-5 w-5" />
              <span className="text-[15px] font-semibold">{label}</span>
            </NavLink>
          ))}

          {/* separator line */}
          <hr
            className="my-3 border-t border-gray-200"
          />

          {/* Sign Out */}
          <button
            type="button"
            onClick={handleSignOutClick}
            className="w-full flex items-center gap-3 px-4 py-3 text-left rounded-xl font-semibold text-red-600 hover:bg-red-50"
          >
            <LogOut className="h-5 w-5" />
            <span>Sign Out</span>
          </button>
        </nav>
      </Card>

      {/* Sign Out Confirmation Modal */}
      <SleekSignOutDialog
        isOpen={showSignOutModal}
        onClose={() => setShowSignOutModal(false)}
        onConfirm={handleConfirmSignOut}
      />
    </aside>
  );
}
